import {
  CContainer,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CNavItem,
  CHeader,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilHome, cilMoney, cilFile, cilList, cilExitToApp, cilAddressBook, cilDevices, cilDelete} from '@coreui/icons'
import { logout } from '../utils/auth'
import { useState } from 'react'
import logo from "../assets/img/Hat_Final.png";

export default function MainLayout({ children }) {
  const [sidebarVisible, setSidebarVisible] = useState(true)
  const [profileOpen, setProfileOpen] = useState(false)
  const username = localStorage.getItem("username");
  return (
    <div className="app-wrapper">
      {/* ===== SIDEBAR ===== */}
      <CSidebar
        visible={sidebarVisible}
        onVisibleChange={setSidebarVisible}
        className={`custom-sidebar ${sidebarVisible ? 'expanded' : 'collapsed'}`}
      >
        <CSidebarBrand className="sidebar-logo text-center">
          <img
            src={logo}
            alt="LOGPOSE"
            style={{ width: "2rem", opacity: 0.95 }}
          />
          {sidebarVisible && <span className="ms-2 text-white">LOGPOSE</span>}
        </CSidebarBrand>

        <CSidebarNav>
          <CNavItem href="/clientes" className="sidebar-link">
            <CIcon icon={cilAddressBook} className="me-2 text-white" />{' '}
            {sidebarVisible && (<span className='text-white fw-semibold text-white'>Clientes</span>)}
          </CNavItem>
          <CNavItem href="/productos" className="sidebar-link">
            <CIcon icon={cilDevices} className="me-2 text-white" />{' '}
            {sidebarVisible && (<span className='text-white fw-semibold text-white'>Productos</span>)}
          </CNavItem>
          <CNavItem href="/ventas" className="sidebar-link">
            <CIcon icon={cilMoney} className="me-2 text-white" />{' '}
            {sidebarVisible && (<span className='text-white fw-semibold text-white'>Ventas</span>)}
          </CNavItem>

          <CNavItem href="/emisiones" className="sidebar-link">
            <CIcon icon={cilFile} className="me-2 text-white" />{' '}
            {sidebarVisible && (<span className='text-white fw-semibold text-white'>Emisiones</span>)}
          </CNavItem>

          <CNavItem href="/anulaciones" className="sidebar-link">
            <CIcon icon={cilDelete} className="me-2 text-white" />{' '}
            {sidebarVisible && (<span className='text-white fw-semibold text-white'>Anulaciones</span>)}
          </CNavItem>

          <CNavItem href="/historial" className="sidebar-link">
            <CIcon icon={cilList} className="me-2 text-white" />{' '}
            {sidebarVisible && (<span className='text-white fw-semibold text-white'>Historial</span>)}
          </CNavItem>
        </CSidebarNav>
      </CSidebar>

      {/* ===== CONTENIDO PRINCIPAL ===== */}
      <div className="main-content d-flex flex-column flex-grow-1 text-white">
        {/* HEADER */}
        <CHeader className="custom-header d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <button
              className="btn btn-sm menu-btn text-white fw-semibold text-white"
              onClick={() => setSidebarVisible(!sidebarVisible)}
            >
              ☰ Menú
            </button>
          </div>

          {/* Profile menu */}
          <div className="position-relative">
            <div
              className="profile-circle"
              onClick={() => setProfileOpen(!profileOpen)}
            >
              {username.at(0).toUpperCase()}
            </div>

            {profileOpen && (
              <div className="profile-menu">
                <p className='p-1 text-center'><strong>Usuario: </strong> {username}</p>
                <button onClick={logout}><CIcon icon={cilExitToApp} className="me-2 text-white" /> Cerrar sesión</button>
              </div>
            )}
          </div>
        </CHeader>

        {/* CONTENIDO */}
        <CContainer fluid className="py-4 flex-grow-1">
          {children}
        </CContainer>

        {/* FOOTER */}
        <footer className="custom-footer text-center py-3">
          © {new Date().getFullYear()} LogPose POS — Sistema de Facturación
        </footer>
      </div>
    </div>
  )
}
